/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Hosted MCP server filter option with usage in the selected time window
 */
export type ToolUsageHostedServerFilterOption = {
  /**
   * Number of tool usage events observed for the hosted MCP server
   */
  eventCount: number;
  /**
   * MCP server id to filter by; absent when the server has no mcp_servers row
   */
  mcpServerId?: string | undefined;
  /**
   * Hosted MCP toolset display name
   */
  toolsetName: string;
  /**
   * Hosted MCP toolset slug
   */
  toolsetSlug: string;
};

/** @internal */
export const ToolUsageHostedServerFilterOption$inboundSchema: z.ZodMiniType<
  ToolUsageHostedServerFilterOption,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    mcp_server_id: z.optional(z.string()),
    toolset_name: z.string(),
    toolset_slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "mcp_server_id": "mcpServerId",
      "toolset_name": "toolsetName",
      "toolset_slug": "toolsetSlug",
    });
  }),
);

export function toolUsageHostedServerFilterOptionFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageHostedServerFilterOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageHostedServerFilterOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageHostedServerFilterOption' from JSON`,
  );
}
